import { createSlice } from '@reduxjs/toolkit';
import {
  fetchPendingFormsThunk,
  fetchAllFormsThunk,
  approveFormThunk,
} from '../thunks/crmFormsThunks';

const initialState = {
  pendingLeads: [],
  pendingPatients: [],
  pendingLoading: false,
  pendingError: null,

  allForms: [],
  allFormsLoading: false,
  allFormsError: null,

  activeFormTab: 'pending',
};

const crmFormsSlice = createSlice({
  name: 'crmForms',
  initialState,
  reducers: {
    setPendingForms: (state, action) => {
      state.pendingLeads = action.payload.leads || [];
      state.pendingPatients = action.payload.patients || [];
    },
    setAllForms: (state, action) => {
      state.allForms = action.payload;
    },
    setActiveFormTab: (state, action) => {
      state.activeFormTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchPendingFormsThunk — payload: { leads: [], patients: [] }
      .addCase(fetchPendingFormsThunk.pending, (state) => {
        state.pendingLoading = true;
        state.pendingError = null;
      })
      .addCase(fetchPendingFormsThunk.fulfilled, (state, action) => {
        state.pendingLeads = action.payload.leads || [];
        state.pendingPatients = action.payload.patients || [];
        state.pendingLoading = false;
      })
      .addCase(fetchPendingFormsThunk.rejected, (state, action) => {
        state.pendingLoading = false;
        state.pendingError = action.error.message;
      })

      // fetchAllFormsThunk
      .addCase(fetchAllFormsThunk.pending, (state) => {
        state.allFormsLoading = true;
        state.allFormsError = null;
      })
      .addCase(fetchAllFormsThunk.fulfilled, (state, action) => {
        state.allForms = action.payload;
        state.allFormsLoading = false;
      })
      .addCase(fetchAllFormsThunk.rejected, (state, action) => {
        state.allFormsLoading = false;
        state.allFormsError = action.error.message;
      })

      // approveFormThunk — arg: { id, type }
      .addCase(approveFormThunk.pending, () => {})
      .addCase(approveFormThunk.fulfilled, () => {})
      .addCase(approveFormThunk.rejected, () => {});
  },
});

export const {
  setPendingForms,
  setAllForms,
  setActiveFormTab,
} = crmFormsSlice.actions;

export default crmFormsSlice.reducer;
